import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Select,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import {
  IconBarcode,
  IconBuildingFactory2,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconCalendar,
  IconCircleCheck,
  IconFileTypeCsv,
  IconSearch,
  IconTag,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import {
  changeSearchValue,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import { formatDateTime } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { getMasterOrgSelect } from "../../../service/getSelectApi";
import { BASE_API_MDM } from "../../../config";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import dayjs from "dayjs";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const ReportSerialStatus = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);
  const [search, setSearch] = useState<any>({
    MaChiNhanh: _searchJson && checkedPinSearch ? _searchJson.MaChiNhanh : "",
    MaKho: _searchJson && checkedPinSearch ? _searchJson.MaKho : "",
    MaNhaCungCap:
      _searchJson && checkedPinSearch ? _searchJson.MaNhaCungCap : "",
    TrangThaiSerial:
      _searchJson && checkedPinSearch ? _searchJson.TrangThaiSerial : "",
    // MaNhom: _searchJson && checkedPinSearch ? _searchJson.MaNhom : "",
    TuNgayNhap: _searchJson && checkedPinSearch ? _searchJson.TuNgayNhap : "",
    DenNgayNhap: _searchJson && checkedPinSearch ? _searchJson.DenNgayNhap : "",
    NgayNhap: _searchJson && checkedPinSearch ? _searchJson.NgayNhap : "",
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );
  const [serial, setSerial] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.serial : "",
    300,
  );
  const [itemCode, setItemCode] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.itemCode : "",
    300,
  );
  const [itemName, setItemName] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.itemName : "",
    300,
  );

  const [dataBranchSelect, setDataBranchSelect] = useState<any[]>([]);
  const [dataInventorySelect, setDataInventorySelect] = useState<
    ComboboxItem[]
  >([]);
  const [dataVendorSelect, setDataVendorSelect] = useState<ComboboxItem[]>([]);
  const [dataSerialStatusSelect, setDataSerialStatusSelect] = useState<
    ComboboxItem[]
  >([]);

  //   const [searchCatSegment5e, setSearchCatSegment5e] = useState<string>("");
  //   const [debounceSearch5e] = useDebouncedValue<string>(searchCatSegment5e, 500);
  //   const [dataCatSegment5eSelect, setDataCatSegment5eSelect] = useState<
  //     ComboboxItem[]
  //   >([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "soCTPos",
        header: "Số chứng từ POS",
      },
      {
        accessorKey: "serial",
        header: "Serial",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge variant="dot" color="green">
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "tenTTSerial",
        header: "Tình trạng Serial",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {[row.original.maTTSerial, row.original.tenTTSerial]
              .filter((i) => i && String(i).length > 0)
              .join(" - ")}
          </Text>
        ),
      },
      {
        accessorKey: "ghiChuTTSerial",
        header: "Ghi chú tình trạng Serial",
        size: 225,
      },
      {
        accessorKey: "maCN",
        header: "Chi nhánh",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(String(renderedCellValue), dataBranchSelect, "label")}
          </Text>
        ),
      },
      {
        accessorKey: "maKho",
        header: "Kho",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {[row.original.maKho, row.original.tenKho]
              .filter((i) => i && String(i).length > 0)
              .join(" - ")}
          </Text>
        ),
      },
      { accessorKey: "tenViTri", header: "Vị trí kho" },
      {
        accessorKey: "maVT",
        header: "Mã vật tư",
        Cell: ({ renderedCellValue }) => (
          <Badge variant="light" bd={"1px solid blue"}>
            {renderedCellValue}
          </Badge>
        ),
      },
      { accessorKey: "tenVT", header: "Tên vật tư" },
      { accessorKey: "dvt", header: "Đơn vị tính" },
      {
        accessorKey: "soCTNhap",
        header: "Số phiếu nhập",
      },
      {
        accessorKey: "ngayCTNhap",
        header: "Ngày nhập NCC",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue && formatDateTime(String(renderedCellValue))}
          </Text>
        ),
      },
      {
        accessorKey: "maNCC",
        header: "Nhà cung cấp",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {[row.original.maNCC, row.original.tenNCC]
              .filter((i) => i && String(i).length > 0)
              .join(" - ")}
          </Text>
        ),
      },
    ],
    [dataBranchSelect],
  );

  const fetchData = async () => {
    const fromDate = new Date(search.TuNgayNhap);
    const toDate = new Date(search.DenNgayNhap);

    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 1);

    if (serial || itemCode || toDate <= maxAllowedDate) {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);
      try {
        let url = `/api/v1/BaoCaoSerial/get-list?Skip=${
          pagination.pageIndex * pagination.pageSize
        }&Take=${pagination.pageSize}`;

        const params = new URLSearchParams();
        Object.entries(search).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => params.append(key, String(item)));
          } else if (typeof value === "string" && value.length > 0) {
            params.append(key, value);
          }
        });

        if (keySearch.length > 0) {
          url += `&KeySearch=${keySearch?.trim()}`;
        }

        if (serial.length > 0) {
          url += `&Serial=${serial}`;
        }

        if (itemCode.length > 0) {
          url += `&MaVatTu=${itemCode}`;
        }

        if (itemName.length > 0) {
          url += `&TenVatTu=${itemName}`;
        }

        url += `&${params.toString()}`;

        const res = await repositoryMdm.get<MessageResponse<any>>(url);

        if (res && res.success) {
          const result = res.data;
          setData(result);
          setRowCount(res.totalCount);
        } else {
          setData([]);
        }
      } catch (error) {
        setData([]);
        setIsError(true);
        console.error(error);
        return;
      } finally {
        setIsLoading(false);
        setIsRefetching(false);
        sessionStorage.setItem(
          String(location.pathname),
          JSON.stringify({
            ...search,
            keySearch: keySearch,
            serial: serial,
            itemCode: itemCode,
            itemName: itemName,
          }),
        );
      }
    } else {
      NotificationExtension.Fails(
        "Vui lòng nhập tham số tìm kiếm serial hoặc mã sản phẩm hoặc lọc dữ liệu trong khoảng 1 tháng !",
      );
    }
  };

  const exportDataExcel = async () => {
    const fromDate = new Date(search.TuNgayNhap);
    const toDate = new Date(search.DenNgayNhap);

    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 1);

    if (serial || itemCode || toDate <= maxAllowedDate) {
      open();
      try {
        let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

        const params = new URLSearchParams();
        Object.entries(search).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => params.append(key, String(item)));
          } else if (typeof value === "string" && value.length > 0) {
            params.append(key, value);
          }
        });

        if (keySearch.length > 0) {
          url += `&KeySearch=${keySearch?.trim()}`;
        }

        url += `&${params.toString()}`;

        const baseUrl = `/api/v1/BaoCaoSerial/export-thong-tin-serial${url}`;

        const _url = BASE_API_MDM + baseUrl;
        const token = localStorage.getItem("token");

        const response = await fetch(_url, {
          method: "GET",
          headers: {
            "Content-Type": "application/vnd.ms-excel",
            Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
          },
        });

        if (!response.ok) {
          NotificationExtension.Fails("Export Excel thất bại !");
        } else {
          const blob = await response.blob();
          const urlss = window.URL.createObjectURL(blob);
          const _name = new Date().toISOString().slice(0, 10);
          let filename = "bao_cao_trang_thai_serial.xlsx";
          const link = document.createElement("a");
          link.href = urlss;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
          NotificationExtension.Success("Export Excel thành công !");
        }
      } catch (error) {
        console.log(error);
      } finally {
        close();
      }
    } else {
      NotificationExtension.Fails(
        "Vui lòng nhập tham số tìm kiếm serial hoặc mã sản phẩm hoặc export excel dữ liệu trong khoảng 1 tháng !",
      );
    }
  };

  const getDataBranchSelect = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: String(item.att1),
          id: String(item.value),
        }));
      setDataBranchSelect(data);
    }
  };

  const fetchDataInventory = async () => {
    let url = "";

    if (search.MaChiNhanh) {
      url += `/api/v1/TblDmInventory/get-list-by-branchs?Skip=0&Take=50&BranchId=${getValueById(
        String(search.MaChiNhanh),
        dataBranchSelect,
        "id",
      )}`;
    } else {
      url += `/api/v1/TblDmInventory/get-all`;
    }

    const res = await repositoryDelivery.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const result = res.data;
      const data = result
        ?.filter((item: any) => item.code && item.name)
        ?.map((item: any) => ({
          label: `${item.code} - ${item.name}`,
          value: String(item.code),
        }));
      setDataInventorySelect(data);

      if (
        search.MaChiNhanh &&
        !data.map((i: any) => i.value)?.includes(search.MaKho)
      ) {
        changeSearchValue("", "MaKho", setSearch);
      }
    }
  };

  const getDataVendorSelect = async () => {
    const getData = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblVendor/get-all",
    );

    if (getData && getData?.success) {
      const result = getData.data;
      setDataVendorSelect(
        result
          ?.filter(
            (item: any) => item.vendorName != null && item.vendorCode != null,
          )
          ?.map((item: any) => ({
            value: item.vendorCode,
            label: `${item.vendorCode} - ${item.vendorName}`,
          })),
      );
    }
  };

  const getDataSerialStatusSelect = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblSerialStatus/get-list?Skip=0&Take=200",
    );

    if (res && res.success) {
      const result = res.data;
      const data = result
        .filter((i: any) => i.code && i.name && i.status === "Y")
        .map((i: any) => ({
          label: `${i.code} - ${i.name}`,
          value: String(i.name),
        }));
      setDataSerialStatusSelect(data);
    }
  };

  //   const getCatSegment5e = async () => {
  //     let url = `/api/v1/TblCatSegment5e/get-list?Skip=0&Take=50`;

  //     if (debounceSearch5e.length > 2) {
  //       url += `&KeySearch=${debounceSearch5e}`;
  //     }

  //     const res = await repositoryPos.get<MessageResponse<any>>(url);

  //     if (res && res.success) {
  //       const data = res.data
  //         ?.filter((item: any) => item.codeString && item.name)
  //         ?.map((item: any) => ({
  //           label: `${item.codeString} - ${item.name}`,
  //           value: item.codeString?.toString(),
  //         }));

  //       setDataCatSegment5eSelect(data);
  //     }
  //   };

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
    }
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    Promise.all([
      getDataBranchSelect(),
      getDataVendorSelect(),
      getDataSerialStatusSelect(),
    ]);
  }, []);

  useEffect(() => {
    fetchDataInventory();
  }, [search.MaChiNhanh]);

  //   useEffect(() => {
  //     getCatSegment5e();
  //   }, [debounceSearch5e]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningReportSerialStatus",
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
        left: ["mrt-row-select", "mrt-row-numbers"],
        right: ["action"],
      }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage(),
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningReportSerialStatus",
      JSON.stringify(columnPinning),
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"md"}>
            <Button
              leftSection={<IconFileTypeCsv size={16} />}
              onClick={() => exportDataExcel()}
            >
              Export Excel
            </Button>
          </Flex>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.TuNgayNhap && search.TuNgayNhap?.length > 0
                  ? new Date(search.TuNgayNhap ?? "")
                  : null
              }
              onChange={(e) => {
                const formattedDate = e
                  ? dayjs(e).format("DD-MMM-YY").toUpperCase()
                  : "";

                changeSearchValue(formattedDate, "TuNgayNhap", setSearch);
              }}
              leftSection={<IconCalendar color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.DenNgayNhap && search.DenNgayNhap?.length > 0
                  ? new Date(search.DenNgayNhap ?? "")
                  : null
              }
              onChange={(e) => {
                const formattedDate = e
                  ? dayjs(e).format("DD-MMM-YY").toUpperCase()
                  : "";

                changeSearchValue(formattedDate, "DenNgayNhap", setSearch);
              }}
              leftSection={<IconCalendar color="#15aabf" />}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Chi nhánh"
              data={dataBranchSelect.map((i) => ({
                label: i.label,
                value: i.value,
              }))}
              leftSection={<IconBuildingSkyscraper color="#15aabf" />}
              value={search.MaChiNhanh ? String(search.MaChiNhanh) : null}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) =>
                changeSearchValue(e ? e : "", "MaChiNhanh", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Kho"
              data={dataInventorySelect}
              leftSection={<IconBuildingWarehouse color="#15aabf" />}
              value={search.MaKho ? String(search.MaKho) : null}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) =>
                changeSearchValue(e ? e : "", "MaKho", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Nhà cung cấp"
              data={dataVendorSelect}
              leftSection={<IconBuildingFactory2 color="#15aabf" />}
              value={search.MaNhaCungCap ? String(search.MaNhaCungCap) : null}
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) =>
                changeSearchValue(e ? e : "", "MaNhaCungCap", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Serial"
              leftSection={<IconBarcode color="#15aabf" />}
              defaultValue={serial}
              onChange={(e) => setSerial(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Mã vật tư"
              leftSection={<IconBarcode color="#15aabf" />}
              defaultValue={itemCode}
              onChange={(e) => setItemCode(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Tên vật tư"
              leftSection={<IconTag color="#15aabf" />}
              defaultValue={itemName}
              onChange={(e) => setItemName(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Tình trạng serial"
              data={dataSerialStatusSelect}
              leftSection={<IconCircleCheck color="#15aabf" />}
              value={
                search.TrangThaiSerial ? String(search.TrangThaiSerial) : null
              }
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) =>
                changeSearchValue(e ? e : "", "TrangThaiSerial", setSearch)
              }
            />
          </Grid.Col>
          {/* <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Nhóm vật tư"
              data={dataCatSegment5eSelect}
              leftSection={<IconFolders color="#15aabf" />}
              value={search.MaNhom ? String(search.MaNhom) : null}
              searchable
              clearable
              onSearchChange={setSearchCatSegment5e}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) =>
                changeSearchValue(e ? e : "", "MaNhom", setSearch)
              }
            />
          </Grid.Col> */}
          {/*<Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Ngày nhập"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.NgayNhap && search.NgayNhap?.length > 0
                  ? new Date(search.NgayNhap ?? "")
                  : null
              }
              onChange={(e) => {
                const formattedDate = e
                  ? dayjs(e).format("DD-MMM-YY").toUpperCase()
                  : "";

                changeSearchValue(
                  formattedDate,
                  "NgayNhap",
                  setSearch,
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
            />
          </Grid.Col>*/}
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ReportSerialStatus;
